var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContentEditor'),(_vm.images)?_c('CopySocialImagesGallery',{attrs:{"images":_vm.images}}):_vm._e(),(_vm.ragDocuments.length > 0 || _vm.ragLinks.length > 0)?_c('RagAdditionalSource',{attrs:{"documents":_vm.ragDocuments,"links":_vm.ragLinks}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }